export default {
  maxsize: `<svg viewBox="0 0 18 18">
      <path d="M2 6 L 2 2 6 2M12 2 L 16 2 16 6" class="ql-stroke"></path>
      <path d="M2 12 L 2 16 6 16M12 16 L 16 16 16 12" class="ql-stroke"></path>
    </svg>`,
  minsize: `<svg viewBox="0 0 18 18">
      <path d="M2 6 L 6 6 6 2M12 2 L 12 6 16 6" class="ql-stroke"></path>
      <path d="M2 12 L 6 12 6 16M12 16 L 12 12 16 12" class="ql-stroke"></path>
    </svg>`
}



// WEBPACK FOOTER //
// ./src/quill-editor/icons.js